























































































































































































































































































































































































































































































































































































interface DropTitle {
	isDim: number;
	isNumCurr: number;
	isNum: number;
	isCurr: number;
}
interface SubVal {
	id: number;
	no: string;
	longText: string;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import SideNavVue from "../components/SideNav.vue";
import SubjectAssistBalanceVue from "../components/Balance/SubjectAssistBalance.vue";
import CurrencyAndSumDialogVue from "../components/Balance/CurrencyAndSumDialog.vue";
import SubsidiaryLedgerVue from "./SubsidiaryLedger.vue";
import version from "@/version";
import { shell } from "electron";

@Component({
	components: {
		"month-selector": MonthSelectorVue,
		"side-nav": SideNavVue,
		"subjectAssist-balance": SubjectAssistBalanceVue,
		"currencyAndSum-dialog": CurrencyAndSumDialogVue,
		"subsisiary-dialog": SubsidiaryLedgerVue,
	},
})
export default class Balance extends Vue {
	@Prop({ type: Array })
	appointDate?: Date[];

	@Prop({ type: Boolean })
	isDialog?: boolean;

	dropTitle: DropTitle = {
		isDim: 0,
		isNumCurr: 0,
		isNum: 0,
		isCurr: 0,
	};
	balContentNowYear: boolean = false; //是否展示本年累计
	isRetract: boolean = true; //展开收起
	currentAccountTypeName: string = "";
	tableData: Balance.Balance[] = [];
	iconIndex: number | null = null;

	pdf(){
		let url = `${Vue.axios.defaults.baseURL}export/pdf/balance?accountBookId=${this.$store.state.accountBook.id}&isBNLJ=${this.balContentNowYear ? 1 : 0}&startSubjectNo=${this.startSubject === null ? "" : this.startSubject.no}&endSubjectNo=${this.endSubject === null ? "" : this.endSubject.no}&minLevel=${this.startLevel}&maxLevel=${this.endLevel}&isShowDim=${this.isShowDim ? 1 : 0}&isHideZeroEnd=${this.isHideZeroEnd ? 1 : 0}&isHideZeroEnd=${this.isHideZeroEnd ? 1 : 0}&isHideZeroFs=${this.isHideZeroFs ? 1 : 0}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}`;
        this.$utils.sendToElectron("download-pdf", url);
	}

	// 是否展示查看明细帐的icon
	showIcon(i: number) {
		this.iconIndex = i;
	}
	offIcon() {
		this.iconIndex = null;
	}
	// 下载
	downLoad(){
	    let url = `${Vue.axios.defaults.baseURL}export/balance?accountBookId=${this.$store.state.accountBook.id}&isBNLJ=${this.balContentNowYear ? 1 : 0}&startSubjectNo=${this.startSubject === null ? "" : this.startSubject.no}&endSubjectNo=${this.endSubject === null ? "" : this.endSubject.no}&minLevel=${this.startLevel}&maxLevel=${this.endLevel}&isShowDim=${this.isShowDim ? 1 : 0}&isHideZeroEnd=${this.isHideZeroEnd ? 1 : 0}&isHideZeroEnd=${this.isHideZeroEnd ? 1 : 0}&isHideZeroFs=${this.isHideZeroFs ? 1 : 0}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&token=${this.$store.state.account.token}&version=${version}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
	}

	//改变时间
	period: String[] = []; // 日期
	dailogDate: Date[] = []; //弹窗日期
	changeDate(date: string[]) {
		this.period = date;
		let date1 = new Date(
			this.period[0].substring(0, 4) + "-" + this.period[0].substring(4)
		);
		let date2 = new Date(
			this.period[1].substring(0, 4) + "-" + this.period[1].substring(4)
		);
		this.dailogDate = [date1, date2];
		this.fetchData();
		// this.fetchSubjects();
		this.startPeriod = date[0];
		this.endPeriod = date[1];
	}
	startPeriod: string = "";
	endPeriod: string = "";
	//科目弹窗中的时间
	get yearMonth() {
		if (this.startPeriod === this.endPeriod) {
			return (
				this.startPeriod.substring(0, 4) +
				"年" +
				this.startPeriod.substring(4) +
				"月"
			);
		} else {
			return (
				this.startPeriod.substring(0, 4) +
				"年" +
				this.startPeriod.substring(4) +
				"月至" +
				this.endPeriod.substring(0, 4) +
				"年" +
				this.endPeriod.substring(4) +
				"月"
			);
		}
	}
	searchData:any = {}
	// 余额表选择下拉
	dialogStatusNum: string = "";
	dialogTitle: string = "";
	handleCommand(command: string) {
		this.dialogStatusNum = command;
		if (command == "科目辅助余额表") {
			this.isSubBalance = true;
		} else if (command == "1") {
			this.dialogTitle = "数量金额余额表";
			this.isCurrencyNum = true;
		} else if (command == "2") {
			this.dialogTitle = "外币金额余额表";
			this.isCurrencyNum = true;
		} else if (command == "3") {
			this.dialogTitle = "数量外币余额表";
			this.isCurrencyNum = true;
		}
		this.searchData = {
			balContentNowYear:this.balContentNowYear,
			startSubjectNo: this.startSubject,
			endSubjectNo: this.endSubject,
			minLevel: this.startLevel,
			maxLevel: this.endLevel,
			isShowDim: this.isShowDim, 
			isHideZeroEnd: this.isHideZeroEnd, 
			isHideZeroFs: this.isHideZeroFs, 
	    }
	}

	// 科目辅助余额表弹窗是否打开
	isSubBalance: boolean = false;
	closeSubBalance() {
		this.isSubBalance = false;
	}

	isCurrencyNum: boolean = false;
	closeCurrencyNum() {
		this.isCurrencyNum = false;
	}

	// 是否下拉
	get dropDownIcon() {
		if (
			this.dropTitle.isDim != 0 ||
			this.dropTitle.isNumCurr != 0 ||
			this.dropTitle.isNum != 0 ||
			this.dropTitle.isCurr != 0
		) {
			return true;
		} else {
			return false;
		}
	}

	subjectList = [];
	// 获取所有科目
	fetchSubjects() {
		Vue.axios
			.post(`balances/find`, {
				accountBookId: this.$store.state.accountBook.id,
				buttonStatus: 0,
				isBNLJ: 0,
				startPeriod: this.period[0],
				endPeriod: this.period[1],
				startSubjectNo: null,
				endSubjectNo: null,
				minLevel: 1,
				maxLevel: 5,
				isShowDim: 0,
				isHideZeroEnd: 0,
				isHideZeroFs: 0,
			}).then(res => {
				for (let i = 0; i < res.data.balances.length; i++) {
					res.data.balances[i].index = i;
				}
				this.subjectList = res.data.balances;
			});
	}
	// 获取表格数据
	fetchData() {
		this.tableData = [];
		Vue.axios
			.post(`balances/find`, {
				accountBookId: this.$store.state.accountBook.id,
				buttonStatus: 0,
				isBNLJ: this.balContentNowYear ? 1 : 0,
				startPeriod: this.period[0],
				endPeriod: this.period[1],
				startSubjectNo: this.startSubject === null ? null : this.startSubject.no,
				endSubjectNo: this.endSubject === null ? null : this.endSubject.no,
				minLevel: this.startLevel,
				maxLevel: this.endLevel,
				isShowDim: this.isShowDim ? 1 : 0,
				isHideZeroEnd: this.isHideZeroEnd ? 1 : 0,
				isHideZeroFs: this.isHideZeroFs ? 1 : 0,
			})
			.then(res => {
				for (let i = 0; i < res.data.balances.length; i++) {
					if (
						res.data.balances[i].isLeaf === 0 &&
						res.data.balances[i].no != null
					) {
						res.data.balances[i].isOpen = true;
					}
					res.data.balances[i].isCanEdit = true;
					res.data.balances[i].index = i;
				}
				
				for (let i = 0; i < this.tableData.length; i++) {
					if (!this.isRetract) {
						if (
							(this.tableData[i].isLeaf != 0 ||
								this.tableData[i].level != 1) &&
							this.tableData[i].no != null
						) {
							this.tableData[i].isCanEdit = false;
						}
						if (
							this.tableData[i].isLeaf === 0 &&
							this.tableData[i].no != null
						) {
							this.tableData[i].isOpen = false;
						}
						if (
							this.tableData[i].isLeaf === 1 &&
							this.tableData[i].level === 1 &&
							this.tableData[i].no != null
						) {
							this.tableData[i].isCanEdit = true;
						}
					}
				}
				this.dropTitle.isDim = res.data.isDim;
				this.dropTitle.isCurr = res.data.isCurr;
				this.dropTitle.isNum = res.data.isNum;
				this.dropTitle.isNumCurr = res.data.isNumCurr;

				this.tableData = Object.freeze(res.data.balances);
			});
	}

	// 明细账模态框
	showSubsidiary: boolean = false;
	relation: Assist.Relation | null = null; //明细账弹窗的relation
	subVal: SubVal = {
		id: 0,
		no: "",
		longText: "",
	};
	subsidiary(data: Balance.Balance) {
		this.subVal.id = data.subjectId;
		this.subVal.no = data.no;
		this.subVal.longText = data.text;
		this.relation = data.relation;
		this.showSubsidiary = true;
	}

	// 全部收起展开 按钮
	spreadOut(val: boolean) {
		for (let i = 0; i < this.tableData.length; i++) {
			if (val) {
				if (
					(this.tableData[i].isLeaf != 0 || this.tableData[i].isLeaf === 0) &&
					this.tableData[i].no != null
				) {
					this.tableData[i].isCanEdit = true;
				}
				if (
					this.tableData[i].isLeaf === 0 &&
					this.tableData[i].no != null
				) {
					this.tableData[i].isOpen = true;
				}
			} else {
				if (
					(this.tableData[i].isLeaf != 0 ||
						this.tableData[i].level != this.startLevel) &&
					this.tableData[i].no != null
				) {
					this.tableData[i].isCanEdit = false;
				}
				if (
					this.tableData[i].isLeaf === 1 &&
					this.tableData[i].level === this.startLevel &&
					this.tableData[i].no != null
				) {
					this.tableData[i].isCanEdit = true;
				}
				if (
					this.tableData[i].isLeaf === 0 &&
					this.tableData[i].no != null
				) {
					this.tableData[i].isOpen = false;
				}
			}
		}
	}

	// 点击 收起展开 图标
	iconEdit(data: Balance.Balance, val: boolean) {
		for (let i = 0; i < this.tableData.length; i++) {
			if (this.tableData[i].pno != null) {
				let pno = <string>this.tableData[i].pno
				if (
					pno.substring(0, data.no.length) ===
					data.no
				) {
					if (val) {
						this.tableData[i].isCanEdit = false;
						data.isOpen = false;
					} else {
						this.tableData[i].isCanEdit = true;
						data.isOpen = true;
					}
				}
			}
		}
		// this.retract()
		this.isRetract = this.retract();
		this.$forceUpdate();
	}
	retract() {
		for (let i = 0; i < this.tableData.length; i++) {
			if (!this.tableData[i].isCanEdit) return false;
		}
		return true;
	}

	//展开图标
	openIcon(no: string) {
		let conRow_data_num: any = document.querySelectorAll(
			".con-row[data-num]"
		);
		for (let i = 0; i < conRow_data_num.length; i++) {
			if (conRow_data_num[i].getAttribute("data-num") == no) {
				let elementTrData: any = conRow_data_num[i].getAttribute(
					"data-no"
				);
				conRow_data_num[i].style.display = "";
				if (
					conRow_data_num[i].querySelector(".indent-div i") != null &&
					conRow_data_num[i]
						.querySelector(".indent-div i")
						.getAttribute("class") == "el-icon-caret-bottom"
				) {
					this.openIcon(elementTrData);
				}
			}
		}
	}

	// indent 的值
	showIndent(data: Balance.Balance) {
		if (data.isLeaf != 0 && data.level == 1) {
			return "indent1";
		} else if (data.isLeaf === 0 && data.level === 2) {
			return `indent${data.level - this.startLevel}`;
		} else if (data.isLeaf != 0 && data.level === 2) {
			return `indent${data.level + 1 - this.startLevel}-1`;
		} else if (data.isLeaf === 0 && data.level === 3) {
			return `indent${data.level + 1 - this.startLevel}`;
		} else if (data.isLeaf != 0 && data.level === 3) {
			return `indent${data.level + 1 - this.startLevel}-1`;
		} else if (data.isLeaf === 0 && data.level === 4) {
			return `indent${data.level + 1 - this.startLevel}`;
		} else if (data.isLeaf != 0 && data.level === 4) {
			return `indent${data.level + 1 - this.startLevel}-1`;
		} else if (data.isLeaf === 0 && data.level === 5) {
			return `indent${data.level + 1 - this.startLevel}`;
		} else if (data.isLeaf != 0 && data.level === 5) {
			return `indent${data.level + 1 - this.startLevel}-1`;
		} else if (data.isLeaf != 0 && data.level === 6) {
			return `indent${data.level + 1 - this.startLevel}-1`;
		}
	}

	// 点击侧边按钮
	accItem(item: NavList) {
		let elements: any = document.querySelectorAll(".con-row");
		if (item.number) {
			for (let i = 0; i < elements.length; i++) {
				if (
					elements[i].getAttribute("subtypeCode") ==
					item.number.toString()
				) {
					let autoScroll: any = document.querySelector(
						"#Balance .auto-scroll"
					);
					autoScroll.scrollTop = elements[i].offsetTop;
					break;
				}
			}
		}
	}

	// 余额表筛选
	startSubject: null | Balance.Balance = null;
	endSubject: null | Balance.Balance = null;
	startLevel = 1;
	endLevel = 5;
	minLevel = 1;
	maxLevel = 5;

	isBNLJ = false;
	isShowDim = true;
	isHideZeroEnd = false;
	isHideZeroFs = false;

	filterVisible = false;

	resetFilter() {
		this.startSubject = null;
		this.endSubject = null;
		this.minLevel = 1;
		this.maxLevel = 5;
		this.isBNLJ = false;
		this.isShowDim = true;
		this.isHideZeroEnd = false;
		this.isHideZeroFs = false;
	}

	confirmFilter() {
		this.isRetract = true;
		this.balContentNowYear = this.isBNLJ;
		this.startLevel = this.minLevel;
		this.endLevel = this.maxLevel;
		this.fetchData();
		this.filterVisible = false;
	}
}
